import { render, staticRenderFns } from "./ViberGroup.vue?vue&type=template&id=76696a20&"
import script from "./ViberGroup.vue?vue&type=script&lang=ts&"
export * from "./ViberGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports